import styled from "styled-components"

export default function OrderInfoTable({ title, children }) {
  return (
    <Block>
      <Title>{title}</Title>
      {children}
    </Block>
  )
}

const Block = styled.div`
  margin-bottom: calc(100vw * (52 / 375));
  &:nth-last-child(1) {
    margin-bottom: 0;
  }
`

const Title = styled.h3`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16 / 375));
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: calc(100vw * (13 / 375));
  margin-bottom: calc(100vw * (20 / 375));
`
